import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const NotFound = loadable(() => import(/* webpackChunkName: "NotFound" */ './NotFound'), {
  fallback: <LoadableFallback visible />,
});

const asyncNotFound = ({ route }) => (
  <NotFound route={route} />
);

asyncNotFound.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncNotFound;
